import { render, staticRenderFns } from "./remove-patient-data.vue?vue&type=template&id=3f8a6166&scoped=true&"
import script from "./remove-patient-data.vue?vue&type=script&lang=js&"
export * from "./remove-patient-data.vue?vue&type=script&lang=js&"
import style0 from "./remove-patient-data.vue?vue&type=style&index=0&id=3f8a6166&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f8a6166",
  null
  
)

export default component.exports